import React, { useState, useMemo } from 'react';
import { Button, Modal } from 'antd';
import { useQuery, useMutation } from '@apollo/client';

import TableTransfer from 'src/components/common/TableTransfer';
import { openNotification } from '../common/Notification';

import { userTypVar, userInfoVar } from 'src/apollo/cache';
import * as mutations from 'src/operations/mutations';
import * as queries from 'src/operations/queries';

function AddAssignTestStudents({ visible, handleCancel, class_idx, testUsers, testGroupIdx, testGroupAssignedIdx, refetch }) {
  const [selectKeys, setSelectKeys] = useState([]);
  const [targetKeys, setTargetKeys] = useState([]);
  const [direction, setDirection] = useState([]);

  const { data, loading: getUserLoading } = useQuery(queries.getUser.GET_USERS, {
    fetchPolicy: 'no-cache',
    variables: {
      type: userTypVar().student,
    },
  });

  const [targetStudent, { loading: loadingAdd }] = useMutation(mutations.createTests.ADD_STUDENT_IN_TESTS, {
    onCompleted(data) {
      if (data) {
        refetch();
        openNotification('학생 수정 완료!');
      }
    },
    onError(error) {
      console.log('error', error);
    },
  });

  const onChange = (targetKeys, direction, moveKeys) => {
    setTargetKeys(targetKeys);
    setSelectKeys(targetKeys);
    setDirection(direction);
  };

  const handleStudentSubmit = () => {
    targetStudent({
      variables: {
        class_idx,
        students: targetKeys,
        testGroupIdx: parseInt(testGroupIdx),
        testGroupAssignedIdx: parseInt(testGroupAssignedIdx),
      },
    });

    setSelectKeys([]);
  };

  const users = useMemo(() => {
    if (data) {
      setTargetKeys(testUsers); // 등록학생 체크

      const classUserIdxs = classInUsersIdx(data?.getUsers, class_idx);
      const classUser = data?.getUsers.filter((user) => classUserIdxs.includes(user?.idx));

      return classUser.map((item, i) => {
        return {
          key: item.idx,
          userid: item.id,
          name: item.name,
          email: item.email,
        };
      });
    }
    return [];
  }, [class_idx, data, testUsers]);

  return (
    <>
      <Modal
        className="classroom-swap-modal"
        visible={visible}
        title="학생 추가 / 삭제"
        onCancel={handleCancel}
        width={`70%`}
        footer={[
          <Button key="button" onClick={handleStudentSubmit} type="primary" loading={loadingAdd}>
            수정
          </Button>,
          <Button key="back" onClick={handleCancel}>
            닫기
          </Button>,
        ]}
      >
        <TableTransfer
          loading={getUserLoading}
          dataSource={users}
          titles={['미등록 학생', '등록 학생']}
          targetKeys={targetKeys}
          showSearch={true}
          onChange={onChange}
          filterOption={(inputValue, item) => item.userid.indexOf(inputValue) !== -1 || item.name.indexOf(inputValue) !== -1}
          leftColumns={leftTableColumns}
          rightColumns={rightTableColumns}
          locale={{ itemUnit: '명', itemsUnit: '명' }}
        />
      </Modal>
    </>
  );
}

const leftTableColumns = [
  {
    key: 'id',
    dataIndex: 'userid',
    title: 'ID',
  },
  {
    key: 'name',
    dataIndex: 'name',
    title: '이름',
  },
  // {
  //   key: 'email',
  //   dataIndex: 'email',
  //   title: 'Email',
  // },
];
const rightTableColumns = [
  {
    key: 'id',
    dataIndex: 'userid',
    title: 'ID',
  },
  {
    key: 'name',
    dataIndex: 'name',
    title: '이름',
  },
  // {
  //   key: 'email',
  //   dataIndex: 'email',
  //   title: 'Email',
  // },
];

const classInUsersIdx = (users, class_idx) => {
  return users
    .filter((user) => user.class_student.filter((class_student) => class_student.class.idx === class_idx).length)
    .map((item) => item.idx);
};

export default AddAssignTestStudents;
